import { Answer, EntityProcessInfo } from 'types';
import { LoadingState } from './loadingState';
import { buildLanguageState } from './languageState';
import { buildUserState } from './userState';
import json from '../../../package.json';

export function buildAppState() {
	return {
		context: {} as EntityProcessInfo,
		data: {} as { [key: string]: unknown },
		language: buildLanguageState(),
		loading: LoadingState(),
		riskq: [] as Answer[],
		title: '',
		user: buildUserState(),
		version: json.version
	};
}
